import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";
import DropDownList from "../../coraWebComponents/forms/DropDownList";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import Tooltip from "../../coraWebComponents/forms/Tooltip";

// prop types
import dovodyPropTypes from "../../propTypes/dovodyPropTypes";
import priorityPropTypes from "../../propTypes/priorityPropTypes";

// actions
import * as zpCDovodActions from "../../actions/ciselniky/zpCDovodActions";
import * as zpCPrioritaActions from "../../actions/ciselniky/zpCPrioritaActions";
import * as ziadostActions from "../../actions/ziadostActions";

class DovodZiadosti extends React.Component {
  saveData = async () => {
    const { dovod, priorita, ulozData } = this.props;

    ulozData({ Dovod: dovod, Priorita: priorita });
  };
  // DROP DOWN - DOVOD PROPS
  handleOnChangeDovod = async (name, dovod) => {
    await this.props.changeDovod(dovod);
  };
  // DROP DOWN - PRIORITA PROPS
  handleOnChangePriorita = async (name, priorita) => {
    await this.props.changePriorita(priorita);
  };

  componentDidMount = async () => {
    const { dovody, priority, getDovody, getPriority, setRef } = this.props;

    if (dovody.length === 0) await getDovody();
    if (priority.length === 0) await getPriority();

    setRef(this);
  };

  render() {
    const {
      dovody,
      priority,
      isLoading,
      moveBack,
      moveNext,
      onKeyDown,
      cancel,
      className,
      index,
      dovod,
      priorita
    } = this.props;

    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <div className={`row m-0 ${className}`}>
        <div className={media.matches ? "col-6 offset-3 p-0 forWeb" : "col p-0 forMobile"}>
          <div className="card formular">
            <div className="form-body">
              {/* FORM */}
              <Tooltip>
                <form
                  id={media.matches ? `webForm${index}` : `webMobile${index}`}
                  className="k-form"
                  onSubmit={moveNext}
                  onKeyDown={onKeyDown}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Druh žiadosti</div>
                  </div>

                  <p>&nbsp;</p>
                  {/* DOVODY */}
                  <div className="k-form-field">
                    <span>{"*Druh:"}</span>
                    <DropDownList
                      className="basicwhiteBackground"
                      name="dovod"
                      textField="N_DOVOD"
                      data={dovody}
                      onChange={this.handleOnChangeDovod}
                      value={dovod}
                      notSetValue={!dovod}
                      required
                    />
                  </div>
                  {/* PRIORITY */}
                  <div className="k-form-field">
                    <span>{"*Priorita:"}</span>
                    <DropDownList
                      className="basicwhiteBackground"
                      name="priorita"
                      textField="N_PRIORITA"
                      data={priority}
                      onChange={this.handleOnChangePriorita}
                      value={priorita}
                      notSetValue={!priorita}
                      required
                    />
                  </div>
                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button primary label="Zrusiť" onClick={cancel} />
                    <div className="flexGroup">
                      <Button primary label="Späť" onClick={moveBack} />
                      <Button type="submit" label="Ďalej" primary={true} />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.zpCDovod.isLoading || state.zpCPriorita.isLoading,
  dovod: state.zpCDovod.item,
  priorita: state.zpCPriorita.item,
  dovody: state.zpCDovod.list,
  priority: state.zpCPriorita.list,
});

const mapDispatchToProps = (dispatch) => ({
  changeDovod: (dovod) => dispatch(zpCDovodActions.changeDovod(dovod)),
  changePriorita: (priorita) => dispatch(zpCPrioritaActions.changePriorita(priorita)),
  ulozData: (data) => dispatch(ziadostActions.ulozData(data)),
  getDovody: () => dispatch(zpCDovodActions.getZP_C_DOVOD()),
  getPriority: () => dispatch(zpCPrioritaActions.getZP_C_PRIORITA()),
});

DovodZiadosti.propTypes = {
  setRef: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  dovod: dovodyPropTypes.dovod,
  priorita: priorityPropTypes.priorita,
  dovody: PropTypes.arrayOf(dovodyPropTypes.dovod),
  priority: PropTypes.arrayOf(priorityPropTypes.priorita),
  changeDovod: PropTypes.func,
  changePriorita: PropTypes.func,
  getDovody: PropTypes.func,
  getPriority: PropTypes.func,
  className: PropTypes.string,
  getStepperState: PropTypes.func,
  ulozData: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DovodZiadosti)
);
